(() => {
  const ready = (fn) => (document.readyState !== "loading")
    ? fn()
    : document.addEventListener("DOMContentLoaded", fn);

  ready(() => {
    const bar = document.querySelector("[data-bb-sticky-atc]");
    if (!bar) return;

    // 1) Find the ORIGINAL ATC area on your Pitch PDP (your HTML shows .product-form-buttons)
    // We observe the whole container, not just the button, so it's reliable.
    const atcTarget =
      document.querySelector(".product-form-buttons") ||
      document.querySelector("button[name='add'][type='submit']") ||
      document.querySelector("form[action^='/cart/add']");

    if (!atcTarget) {
      // If we can't find the ATC, don't show sticky bar at all.
      return;
    }

    // 2) Compute header height so sticky bar sits UNDER header on desktop
    const setHeaderOffset = () => {
      // Try common header containers
      const headerGroup = document.querySelector("#header-group");
      const headerEl = document.querySelector("header");

      // Use whichever is present & has a height
      const h1 = headerGroup ? headerGroup.getBoundingClientRect().height : 0;
      const h2 = headerEl ? headerEl.getBoundingClientRect().height : 0;

      // On some themes, header-group wraps announcement+header; pick max.
      const offset = Math.max(h1, h2, 0);

      document.documentElement.style.setProperty("--bb-header-offset", `${Math.round(offset)}px`);
      return offset;
    };

    let headerOffset = setHeaderOffset();
    window.addEventListener("resize", () => {
      headerOffset = setHeaderOffset();
    });

    // 3) Clone Judge.me preview badge into the bar (keeps REAL rating + count)
    const mountReviews = () => {
      const slot = bar.querySelector("[data-bb-sticky-atc-reviews]");
      if (!slot || slot.dataset.mounted === "1") return;

      // Judge.me badge usually exists somewhere near title area
      const jdgm = document.querySelector(".jdgm-widget.jdgm-preview-badge");
      if (!jdgm) return;

      // Clone only the inner badge (avoid duplicating scripts)
      const inner = jdgm.querySelector(".jdgm-prev-badge") || jdgm;
      const clone = inner.cloneNode(true);
      clone.style.display = ""; // your snippet showed display:none sometimes; force visible in bar
      slot.innerHTML = "";
      slot.appendChild(clone);

      slot.dataset.mounted = "1";
    };

    mountReviews();
    // If Judge.me loads late, retry briefly
    let tries = 0;
    const jdgmTimer = setInterval(() => {
      tries++;
      mountReviews();
      if (bar.querySelector("[data-bb-sticky-atc-reviews]")?.dataset.mounted === "1" || tries > 20) {
        clearInterval(jdgmTimer);
      }
    }, 250);

    // 4) Update price + button text when variant changes (simple + robust)
    const priceEl = bar.querySelector("[data-bb-sticky-atc-price]");
    const btnPriceEl = bar.querySelector("[data-bb-sticky-atc-btn-price]");

    const syncPriceFromPage = () => {
      // Try common price selectors; if none, keep Liquid default.
      const priceNode =
        document.querySelector("[data-product-price]") ||
        document.querySelector(".price__current") ||
        document.querySelector(".price-item--regular") ||
        document.querySelector(".product__price .money") ||
        null;

      if (priceNode) {
        const txt = priceNode.textContent.trim();
        if (txt) {
          if (priceEl) priceEl.textContent = txt;
          if (btnPriceEl) btnPriceEl.textContent = txt;
        }
      }
    };

    // Listen for changes from variant picker (Pitch often triggers input/change)
    document.addEventListener("change", (e) => {
      if (e.target && (e.target.name === "id" || e.target.closest?.("variant-selector, variant-selects"))) {
        setTimeout(syncPriceFromPage, 50);
      }
    });

    // 5) Show/hide logic:
    // - Show only when the ORIGINAL ATC is NOT visible AND user has scrolled past it.
    // - Desktop: bar is under header (top offset). Mobile: bar is bottom (CSS).
    let isVisible = false;

    const show = () => {
      if (isVisible) return;
      isVisible = true;
      bar.classList.add("is-visible");
      bar.setAttribute("aria-hidden", "false");
    };

    const hide = () => {
      if (!isVisible) return;
      isVisible = false;
      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
    };

    // IntersectionObserver tells us if ATC area is in view.
    // Root margin accounts for sticky header height so "in view" means "visible under header".
    let io;
    const setupObserver = () => {
      if (io) io.disconnect();

      // recompute header offset each time we rebuild
      headerOffset = setHeaderOffset();

      io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          // If intersecting, original ATC is visible => hide sticky
          if (entry.isIntersecting) {
            hide();
            return;
          }

          // If not intersecting, only show if user scrolled PAST the ATC area.
          const rect = atcTarget.getBoundingClientRect();
          const passedATC = rect.top < headerOffset; // user has moved below it
          if (passedATC) show();
          else hide();
        },
        {
          threshold: 0.05,
          rootMargin: `-${Math.round(headerOffset)}px 0px 0px 0px`,
        }
      );

      io.observe(atcTarget);
    };

    setupObserver();
    window.addEventListener("resize", () => setupObserver());

    // 6) Clicking sticky button should click the REAL add-to-cart button
    const btn = bar.querySelector("[data-bb-sticky-atc-btn]");
    if (btn) {
      btn.addEventListener("click", () => {
        // try the actual submit button from your HTML snippet
        const realBtn =
          atcTarget.querySelector?.("button[type='submit'][name='add']") ||
          document.querySelector("button[type='submit'][name='add']");

        if (realBtn) {
          realBtn.click(); // uses existing theme logic (drawer, etc.)
          return;
        }

        // fallback: submit the form directly
        const form = document.querySelector("form[action^='/cart/add']");
        if (form) form.submit();
      });
    }
  });
})();
